import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { selectAllConversations, selectLoggedInUserDataId } from "src/app/common/store/state/app.state";
import { ConversationDialogComponent } from "../conversation-dialog/conversation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AppFunctions } from "../../constants/app-functions";
import { ObjectSource } from "../../constants/general-basic-data";
import { Conversation } from "../../models/conversation.model";
import { ObjectData } from "../../models/object-data.model";
import { MatIconModule } from "@angular/material/icon";




@Component({
    selector: 'app-conversations',
    templateUrl: './conversations.component.html',
    styleUrls: ['./conversations.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule]
})
  export class ConversationsComponent implements OnInit, AfterViewInit{

    //@Input() conversations$: Observable<Conversation[]>;
    @Input() objectSource: ObjectSource = ObjectSource.DEALER;
    @Input() offerId: string = "";
    @Input() enableNew: boolean = false;

    conversations$: Observable<Conversation[]>;
    conversations: Conversation[] = [];

    @Input() isOwnerPage: boolean = false;

    reply: string = "";
    
    currentUserId$ : Observable<string>;
    currentUserId: string = "";

    ObjectSource = ObjectSource;

    constructor(
       
        private store: Store,
        public dialog: MatDialog) {

          this.conversations$ = this.store.select(selectAllConversations(this.objectSource, this.offerId))
          
          this.currentUserId$ = store.select(selectLoggedInUserDataId);
    
        }
    
    
    ngOnInit(): void {

        this.currentUserId$.subscribe(
            (id: string) => this.currentUserId = id
        );
       // console.log("hrtt "+this.objectSource)
      this.conversations$ = this.store.select(selectAllConversations(this.objectSource, this.offerId))
      
      this.conversations$.subscribe(
        (convs: Conversation[]) => this.conversations = convs
      );

    }

    ngAfterViewInit(): void {
      
  
  } 

    openConversationDialogOld(index: number){

        const dialogRef = this.dialog.open(ConversationDialogComponent, {
          //data: Object.assign(new Conversation(), this.conversations[index])
          data: this.conversations[index]
        });

        /*
        dialogRef.afterClosed().subscribe((result: any) => {
    
            //console.log('New price = '+result+ " car Id = "+carId);
            if(result != undefined ){
              console.log(result);
              result.receiverId = this.provider.username;
              this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, carId: "no_car" }));
            }  
          });
        */
    }

    openConversationDialog(offerId: string, conversationId: number){

      const dialogRef = this.dialog.open(ConversationDialogComponent, {

        data: new ObjectData(this.objectSource, offerId, conversationId)

      });

      /*
      dialogRef.afterClosed().subscribe((result: any) => {
  
          //console.log('New price = '+result+ " car Id = "+carId);
          if(result != undefined ){
            console.log(result);
            result.receiverId = this.provider.username;
            this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, carId: "no_car" }));
          }  
        });
      */
  }
    

    dateFormat(dt: string): string{

        return AppFunctions.stringToDatetime(dt);
        }
    
  }